<template>
  <Popover
    trigger="hover"
    placement="bottom"
    :offset="{ y: 5 }"
  >
    <template #trigger>
      <slot />
    </template>
    <template #content>
      <div class="federation-restrictions-popover">
        <div>{{ $t('federation_restrictions.explanation', {domain}) }}</div>
        <ul class="federation-restrictions-popover">
          <li
            v-for="item in restrictions"
            :key="item.id"
            :style="{opacity: item.active ? 1.0 : 0.5}"
          >
            [{{ formatTime(item.first_seen) }} ~ {{ formatTime(item.last_seen) }}]

            <span
              :title="$t('federation_restrictions.level_' + item.level + '_desc', {domain})"
              class="level"
            >
              {{ $t('federation_restrictions.level_' + item.level) }}
            </span>:
            <span v-if="item.reason">
              {{ item.reason }}
            </span>
            <em v-else>
              (no reason provided)
            </em>
          </li>
        </ul>
      </div>
    </template>
  </Popover>
</template>

<script src="./federation_restrictions_popover.js"></script>

<style lang="scss">
.federation-restrictions-popover {
  padding: 1em;
}

.federation-restrictions-popover .level {
  border-bottom: 1px dotted;
}

.federation-restrictions-popover > ul {
  margin: 0;
  padding: 0 0 0 1em;
}

.federation-restrictions-popover > li {
  margin-top: 1em;
}

.federation-restrictions-popover > div {
  display: inline-block;
  font-weight: bold;
  text-align: center;
  width: 100%;
}
</style>
